import AbstractStore from 'core/abstracts/AbstractStore';
import Dispatcher from 'core/Dispatcher';
import Constants from 'constants.js';

class AccountStore extends AbstractStore {

    constructor() {

        const CHANGE_EVENT = 'ACCOUNT_CHANGE_EVENT';
        const NAME = 'ACCOUNT_STORE';

        super(NAME, CHANGE_EVENT);

        this._initStore();

        // Registers action handler with the Dispatcher.
        Dispatcher.register(this._registerToActions.bind(this));
    }

    _initStore() {
        // Accounts manager
        this.loading = true;
        this.accounts = [];
        this.currentAccount = null;
        this.count = 0;

        // Import update an account
        this.accountDiffStats = null;
        this.loadingDiff = false;
        this.accountUpdateStats = null;
        this.updatingAccount = false;
        this.updatedAdditionalDatas = {};
    }

    isLoading() {
        return this.loading;
    }

    isLoadingDiff() {
        return this.loadingDiff;
    }

    isUpdatingAccount() {
        return this.updatingAccount;
    }

    getAccounts() {
        return this.accounts;
    }

    getCount() {
        return this.count;
    }

    getAccountDiffStats() {
        return this.accountDiffStats;
    }

    getAccountUpdateStats() {
        return this.accountUpdateStats;
    }

    getUpdatedAdditionalDatas() {
        return this.updatedAdditionalDatas;
    }

    setAccounts(accounts) {
        this.accounts = accounts;
    }

    setCount(count) {
        this.count = count;
    }

    setAccountDiffStats(stats) {
        this.accountDiffStats = stats;
    }

    setAccountUpdateStats(stats) {
        this.accountUpdateStats = stats;
    }

    setUpdatedAdditionalDatas(updatedAdditionalDatas) {
        this.updatedAdditionalDatas = updatedAdditionalDatas;
    }

    deleteAccount(id) {
        this.accounts = this.accounts.filter(a => a.id !== id);
    }

    addAccount(account) {
        this.accounts.push(account);
        this.accounts = this.accounts.sort((a,b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : b.name.toLowerCase() > a.name.toLowerCase() ? -1 : 0);
    }

    updateAccount(account) {
        this.accounts = this.accounts.map(a => {
            if (a.id === account.id) {
                return account;
            }

            return a;
        }).sort((a,b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : b.name.toLowerCase() > a.name.toLowerCase() ? -1 : 0);
    }

    // Switches over the action's type when an action is dispatched.
    _registerToActions(action) {
        switch (action.actionType) {
        case Constants.LOGOUT:
            this._initStore();
            this._emitChange();
            break;
        case Constants.ACCOUNTS_GET_START:
            this.loading = true;
            this._emitChange();
            break;
        case Constants.ACCOUNTS_GET_END:
            this.loading = false;
            this.setAccounts(action.value.accounts);
            this.setCount(action.value.count);
            this._emitChange();
            break;
        case Constants.ACCOUNT_ADDED:
            this.addAccount(action.value);
            this._emitChange();
            break;
        case Constants.ACCOUNT_UPDATED:
            this.updateAccount(action.value);
            this._emitChange();
            break;
        case Constants.ACCOUNT_DELETED:
            this.deleteAccount(action.value.id);
            this._emitChange();
            break;
        case Constants.DIFF_IMPORT_ITEMS_START:
            this.loadingDiff = true;
            this._emitChange();
            break;
        case Constants.DIFF_IMPORT_ITEMS_END:
            this.setAccountDiffStats(action.value);
            this.loadingDiff = false;
            this._emitChange();
            break;
        case Constants.EXEC_IMPORT_ITEMS_START:
            this.setUpdatedAdditionalDatas(null);
            this.updatingAccount = true;
            this._emitChange();
            break;
        case Constants.EXEC_IMPORT_ITEMS_END:
            this.setAccountUpdateStats(action.value);
            this.updatingAccount = false;
            this._emitChange();
            break;
        case Constants.EXEC_IMPORT_ADDITIONAL_DATAS_START:
            this.setUpdatedAdditionalDatas(null);
            this.updatingAccount = true;
            this._emitChange();
            break;
        case Constants.EXEC_IMPORT_ADDITIONAL_DATAS_END:
            this.setUpdatedAdditionalDatas(action.value);
            this.updatingAccount = false;
            this._emitChange();
            break;
        case Constants.EXEC_IMPORT_ADDITIONAL_DATAS_ERROR:
            this.updatingAccount = false;
            this._emitChange();
            break;
        default:
            return false;
        }
    }

}

export default new AccountStore();
